var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#054254",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.66667C16.6024 3.66667 20.3333 7.39763 20.3333 12C20.3333 16.6024 16.6024 20.3333 12 20.3333C7.39763 20.3333 3.66667 16.6024 3.66667 12C3.66667 10.6696 3.97843 9.412 4.53289 8.2963",
    stroke: "#054254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusProcessing);
export default __webpack_public_path__ + "static/media/status-processing.3bab3fbffd2b08c47bce2037b9f260b8.svg";
export { ForwardRef as ReactComponent };